import React, { useEffect, useState } from 'react';
import AppointmentForm from '../../components/AppointmentForm';
import HomeBanner from '../../components/HomeBanner';
import ClientReview from '../../components/ClientReview';
import Certification from '../../components/Certification';
import PersonalizedSection from '../../components/PersonalizedSection';
import PersonalizedCarausel from '../../components/PersonalizedCarausel';
import PersonalizedNutrition from '../../components/PersonalizedNutrition';
import Explore from '../../components/Explore';
import { getSeoByUrl } from '../../api/api';

const Home = ({ appointmentRef }) => {
  const [seoData, setSeoData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("home");
        
        if (response.success && response.data) {
          setSeoData(response.data);
          updateMetaTags(response.data);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSeoData();
  }, []);

  const updateMetaTags = (data) => {
    // Update title
    if (data.metaTitle) document.title = data.metaTitle;
    
    // Update or create meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    if (data.metaDescription) metaDesc.setAttribute('content', data.metaDescription);
    
    // Update robots
    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.setAttribute('name', 'robots');
      document.head.appendChild(robotsMeta);
    }
    if (data.robotsTxt) robotsMeta.setAttribute('content', data.robotsTxt);
    
    // Update canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    if (data.canonicalUrl) canonicalLink.setAttribute('href', data.canonicalUrl);
    
    // Add schema markup
    if (data.schemaMarkup) {
      let existingScript = document.querySelector('#schema-markup');
      if (existingScript) existingScript.remove();
      
      const script = document.createElement('script');
      script.id = 'schema-markup';
      script.type = 'application/ld+json';
      script.textContent = data.schemaMarkup;
      document.head.appendChild(script);
    }
  };

  return (
    <>
      <HomeBanner />
      <PersonalizedSection />
      <PersonalizedCarausel />
      <PersonalizedNutrition />
      <Explore />
      <Certification />
      <ClientReview />
      <div ref={appointmentRef}>
        <AppointmentForm />
      </div>
    </>
  );
};

export default Home;